import React, { useEffect, useRef } from "react";

// import { useTranslation } from "react-i18next";
import UserActivityTable from "./UserActivityTable";
import { GridStack } from "gridstack";
import DMSHeader from "../../DMSHeader/DMSHeader";
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";


const UserActivityManagement = () => {
//   const { t, i18n } = useTranslation();

  useEffect(() => {
    GridStack.init();
  }, []);

  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      component: (
        <DMSHeader title={"User Log Activity"} showdownload={true}
        fileName="UserLogTable"/>
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 12,
      id: 2,
      component: <UserActivityTable />,

    },
  ];

  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default UserActivityManagement;
